export default __webpack_public_path__ + "static/media/contactus-bg2.9f507e4b.jpg";